import React from "react";
import PhleboDashboardLeft from "../../Phlebo/dashboard-left";
import PhleboDashboardRight from "../../Phlebo/dashboard-right";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    container: {
        display: 'flex',
        padding: "20px"
    }
});

interface Props {
    children: any;
}

const PhleboDash: React.FC<Props> = ({ children }) => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <PhleboDashboardLeft />
            <PhleboDashboardRight>{children && children}</PhleboDashboardRight>
        </div>
    );
};

export default PhleboDash;

